import { Stack, Typography } from "@mui/material";
import { TextField } from "components/UI";
import { memo } from "react";
import { useTranslation } from "react-i18next";

const StructureDetailDescriptionSection = memo(
  ({ register, errors, isCreatedByUser }) => {
    const { t } = useTranslation();

    return (
      <Stack spacing={1}>
        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
          {t("denominations.structures.description")}
        </Typography>
        <Stack
          sx={{
            backgroundColor: "#DFF5F5",
            borderRadius: "5px",
            px: 4,
            py: 2
          }}
        >
          <TextField
            label={t("denominations.structures.aboutStructure")}
            name="description"
            error={!!errors.description?.message}
            helperText={errors.description?.message}
            register={register}
            isLabelBold={true}
            disabled={!isCreatedByUser}
          />
        </Stack>
      </Stack>
    );
  }
);

StructureDetailDescriptionSection.displayName =
  "StructureDetailDescriptionSection";

export default StructureDetailDescriptionSection;
